import { z } from 'zod';
import { CommunicationTemplateSchema, DocumentTemplateSchema, NoteTemplateSchema, } from '../aggregates/template.js';
const omitProps = {
    lastUpdated: true,
    createdOn: true,
    modifiedBy: true,
};
const requireProps = {
    reasonForUpdate: true,
};
export const UpdateTemplateApiSchema = {
    params: z.object({
        id: z.string(),
    }),
    headers: z.object({
        requestActor: z.string(),
    }),
    body: z.union([
        CommunicationTemplateSchema.omit(omitProps).required(requireProps),
        DocumentTemplateSchema.omit(omitProps).required(requireProps),
        NoteTemplateSchema.omit(omitProps).required(requireProps),
        // TimelineTemplateSchema.omit(omitProps).required(requireProps), // breaks open api schema
    ]),
};
export const UpdateTemplateRequestSchema = UpdateTemplateApiSchema.params
    .and(UpdateTemplateApiSchema.body)
    .and(UpdateTemplateApiSchema.headers);
export const UpdateNoteTemplateApiSchema = {
    params: z.object({
        id: z.string(),
    }),
    headers: z.object({
        requestActor: z.string(),
    }),
    body: NoteTemplateSchema.omit(omitProps).required(requireProps),
};
export const UpdateNoteTemplateRequestSchema = UpdateNoteTemplateApiSchema.params
    .and(UpdateNoteTemplateApiSchema.body)
    .and(UpdateNoteTemplateApiSchema.headers);
export const UpdateDocumentTemplateApiSchema = {
    params: z.object({
        id: z.string(),
    }),
    headers: z.object({
        requestActor: z.string(),
    }),
    body: DocumentTemplateSchema.omit(omitProps).required(requireProps),
};
export const UpdateDocumentTemplateRequestSchema = UpdateDocumentTemplateApiSchema.params
    .and(UpdateDocumentTemplateApiSchema.body)
    .and(UpdateDocumentTemplateApiSchema.headers);
